import { defineMessages } from 'react-intl'

export const activeMessages = defineMessages({
  active: {
    defaultMessage: 'Active',
    description: 'active name',
  },
  inactive: {
    defaultMessage: 'Inactive',
    description: 'active name',
  },
})
